@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  <div class="listWrapper">
    @if (products()) {
      <mat-list>
        @for (product of products(); track product) {
          <mat-list-item class="listItem" (click)="selectProduct(product)"
            (dblclick)="addProduct()"
            [class.selected]="isSelected(product)">{{ product.productId }}
          </mat-list-item>
        }
      </mat-list>
    }
  </div>
  @if (selectedProduct) {
    <div class="productDetail">
      <div class="productDescription">{{ selectedProduct.description }}</div>
      <div class="productNotes" [innerHTML]="selectedProduct.externalNotes"></div>
    </div>
  }
</div>
<div class="buttonWrapper">
  <span class="spacer"></span>
  <button matButton="elevated" class="inputButton warn-button" (click)="close()">Cancel</button>
  <button matButton="elevated" class="inputButton primary-button" [disabled]="!selectedProduct" (click)="addProduct()">Add
    Product
  </button>
</div>
